export class InMemoryCache {
    #cache = new Map();
    #timeouts = new Map();
    async set(key, value, ttl) {
        if (typeof ttl !== 'number' || ttl <= 0)
            throw new Error(`Invalid TTL: ${ttl}`);
        if (this.#timeouts.has(key)) {
            clearTimeout(this.#timeouts.get(key));
        }
        this.#cache.set(key, value);
        const timeout = setTimeout(() => {
            this.#cache.delete(key);
            this.#timeouts.delete(key);
        }, ttl * 1000);
        this.#timeouts.set(key, timeout);
    }
    async get(key) {
        return this.#cache.get(key);
    }
    async delete(key) {
        this.#cache.delete(key);
    }
}
//# sourceMappingURL=cache.js.map